export default "__VITE_ASSET__2172b211__"